import React from 'react';
import queryString from 'query-string';

const SouhlasPage = () => {
  const { token } = queryString.parse(window.location.search);

  if (!token) {
    return <p>Token není zadán.</p>;
  }

  const hostname = window.location.hostname; // např. "vyvoj.myplann.lh"
  const subdomain = hostname.split('.')[0]; // "vyvoj"
  let mydockUrl = process.env.REACT_APP_MYDOCK_URL;
  if(!mydockUrl) {
    mydockUrl = 'mydock.cz';
  }
  const iframeUrl = `https://${subdomain}.${mydockUrl}/web-mydock/client/onboarding/${token}`;

  return (
    <div style={{ position: 'fixed', width: '100%', height: '100%' }}>
      <iframe
        src={iframeUrl}
        title="Souhlas"
        style={{ width: '100%', height: '100%', border: 'none' }}
      />
    </div>
  );
};

export default SouhlasPage;
